export enum FilterGroupRelationshipType {
  AND = 'AND',
  OR = 'OR'
}
